var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74195 4.54358C7.23573 1.95628 7.98261 0.662633 8.96835 0.248267C9.75582 -0.0827555 10.6434 -0.0827555 11.4309 0.248267C12.4166 0.662633 13.1635 1.95628 14.6573 4.54358L18.2772 10.8135C19.771 13.4008 20.5179 14.6945 20.3839 15.7553C20.2768 16.6028 19.833 17.3715 19.1526 17.8879C18.3009 18.5344 16.8071 18.5344 13.8196 18.5344H6.57967C3.59212 18.5344 2.09834 18.5344 1.24662 17.8879C0.566207 17.3715 0.122413 16.6028 0.0153512 15.7553C-0.118666 14.6945 0.628221 13.4008 2.122 10.8135L2.122 10.8135L5.74195 4.54358ZM9.17969 5.99636C9.17969 5.43327 9.63616 4.97681 10.1992 4.97681C10.7623 4.97681 11.2188 5.43327 11.2188 5.99636V11.4728C11.2188 12.0359 10.7623 12.4923 10.1992 12.4923C9.63616 12.4923 9.17969 12.0359 9.17969 11.4728V5.99636ZM10.0195 14C9.45647 14 9 14.4565 9 15.0195C9 15.5826 9.45647 16.0391 10.0195 16.0391C10.5826 16.0391 11.0391 15.5826 11.0391 15.0195C11.0391 14.4565 10.5826 14 10.0195 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2f68f7e72d5e34728decee0769c50c66.svg";
export { ForwardRef as ReactComponent };